define('plugin/product/view/ProductCartItemView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Product item view
     *
     * @class ProductItemView
     */
    return LayoutView.extend({

        getTemplate: function () {
            return '#product_cart_item_view';
        },
        ui: {
            'plus': '.sb-plus',
            'minus': '.sb-minus',
            'delete': '.sb-delete',
        },
        triggers: {
            'click @ui.delete': 'delete',
            'click @ui.plus': 'increment',
            'click @ui.minus': 'decrement',
        },

        modelEvents: {
            'change': 'render',
        },

        serializeData: function () {
            return _.extend(LayoutView.prototype.serializeData.apply(this), {
                amount: this.model.get('qty') * this.model.get('product').price
            });
        }

    });

});
